import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from '@/views/Dashboard.vue'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: { name: 'dashboard' },
      meta: {
        auth: true
      }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        auth: true
      }
    },
    {
      path: '/users',
      name: 'users',
      component: () => import('@/views/Users.vue'),
      meta: {
        title: Vue.i18n.translate('strings.users', null),
        auth: true
      },
      children: [{
        path: ':id',
        name: 'userDetail',
        component: () => import('@/views/Users.vue')
      }]
    },
    {
      path: '/inventories',
      name: 'inventories',
      component: () => import('@/views/Inventories.vue'),
      meta: {
        title: Vue.i18n.translate('strings.Inventories', null),
        auth: true
      },
      children: [{
        path: ':id',
        name: 'inventoryDetail',
        component: () => import('@/views/Inventories.vue')
      }]
    },
    {
      path: '/pos',
      name: 'pos',
      component: () => import('@/views/Pos.vue'),
      meta: {
        title: Vue.i18n.translate('strings.Pos', null),
        auth: true
      },
      children: [{
        path: ':id',
        name: 'posDetail',
        component: () => import('@/views/Pos.vue')
      }]
    },
    {
      path: '/purchase-requisitions',
      name: 'purchaseRequisitions',
      component: () => import('@/views/PurchaseRequisitions.vue'),
      meta: {
        title: Vue.i18n.translate('strings.purchase_requisitions', null),
        auth: true
      }
    },
    {
      path: '/purchase-requisitions/new',
      name: 'newPurchaseRequisition',
      component: () => import('@/views/PurchaseRequisitionsDetail.vue'),
      props: true,
      meta: {
        title: Vue.i18n.translate('strings.purchase_requisitions,detail', null),
        auth: true
      }
    },
    {
      path: '/purchase-requisitions/:id',
      name: 'editPurchaseRequisition',
      component: () => import('@/views/PurchaseRequisitionsDetail.vue'),
      meta: {
        title: Vue.i18n.translate('strings.purchase_requisitions.detail', null),
        auth: true
      }
    },
    // New Route
    {
      path: '/login',
      name: 'login',
      // route level code-splitting
      // this generates a separate chunk (login.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "login" */ '@/views/AuthLogin.vue'),
      meta: {
        title: Vue.i18n.translate('login.login', null),
        auth: false
      }
    },
    {
      path: '/password/reset',
      name: 'reset',
      component: () => import(/* webpackChunkName: "Reset" */ '@/views/AuthResetLink.vue'),
      meta: {
        title: Vue.i18n.translate('login.reset_password', null),
        auth: false
      }
    },
    {
      path: '/password/reset/:token',
      name: 'reset.token',
      component: () => import(/* webpackChunkName: "Reset" */ '@/views/AuthResetForm.vue'),
      meta: {
        title: Vue.i18n.translate('login.reset_password', null),
        auth: false
      }
    }
  ]
})

// It's required for VueAuth
Vue.router = router

export default router
